module.exports = __webpack_public_path__ + "static/img/shsm_port_lg.75dcbb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/silent-hill-shattered-memories-microsite/shsm_port_lg.jpg
// module id = 275
// module chunks = 2